import { render, staticRenderFns } from "./TheEquipmentSection.vue?vue&type=template&id=72347962&scoped=true&"
import script from "./TheEquipmentSection.vue?vue&type=script&lang=ts&"
export * from "./TheEquipmentSection.vue?vue&type=script&lang=ts&"
import style0 from "./TheEquipmentSection.vue?vue&type=style&index=0&id=72347962&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72347962",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Video: require('/opt/build/repo/apps/shop/components/storyblok/Video/Video.vue').default,FCSwiperProgressBar: require('/opt/build/repo/apps/shop/components/FCSwiperProgressBar.vue').default,FCSwiper: require('/opt/build/repo/apps/shop/components/FCSwiper.vue').default})
